import { useState } from 'react';
import _useGetSharedFuelValues from '/business/shared/components/questions/_util_hooks/useGetSharedFuelValues';
import type { FuelType } from '/business/shared/components/questions/_util_hooks/useGetSharedFuelValues';

interface SharedFuelSchemaProps {
  answerHasNoData?: boolean;
  buildingFuelTypes: FuelType[];
  hasAnswer?: boolean;
}

export default function useOnSiteWaterTreatmentSchema({ buildingFuelTypes: fuelTypes }: SharedFuelSchemaProps) {
  const [forceSubmitForm, setForceSubmitForm] = useState(false);
  const [valueFuelType, setValueFuelType] = useState<string | null>(null);

  const { pageSchema } = _useGetSharedFuelValues({
    fuelTypes,
    valueFuelType,
    setValueFuelType,
  });

  return {
    pageSchema,
    forceSubmitForm,
    setForceSubmitForm,
  };
}
